// Service Worker 注册：部署后刷新即可切到新版本（不再要求无痕窗口）

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service worker ready (localhost).');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function activateWaiting(registration, config) {
  if (!registration?.waiting) return;
  try {
    sessionStorage.setItem('sw_update_pending_reload', '1');
  } catch (e) {
    // ignore
  }
  if (config && config.onUpdate) {
    config.onUpdate(registration);
  } else {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // 页面已打开时若已有 waiting 版本，立刻激活
      if (registration.waiting) {
        activateWaiting(registration, config);
      }

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state !== 'installed') return;
          if (navigator.serviceWorker.controller) {
            // 有旧控制器 = 发现新版本
            activateWaiting(registration, config);
          } else if (config && config.onSuccess) {
            config.onSuccess(registration);
          }
        });
      });

      // 回到前台 / 定时检查更新，普通刷新或切回标签即可发现新包
      const checkUpdate = () => {
        registration.update().catch(() => {});
      };
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkUpdate();
      });
      window.addEventListener('focus', checkUpdate);
      setInterval(checkUpdate, 60 * 1000);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
